/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";

window.jQuery = $;
require("hideseek");

/*------------------------------------*\
    CONTACTS MODULE
\*------------------------------------*/
class Contacts {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        var elem = $(this);

        $('.js-contacts__search').hideseek({
            list: '.js-contacts__list',
            highlight: true,
            min_chars: 3
        });

        // After completion of search...
        $('.js-contacts__search').on('_after', function() {

            // Hide groups with no visible children
            $('.js-contacts__list').each(function() {
                var group = $(this),
                    parent = group.parent(),
                    contacts = group.find('.js-contact').filter(function() {
                        return this.style.display !== 'none'
                    });

                if(contacts.length === 0) {
                    parent.hide();
                } else {
                    parent.show();
                }
            });

            // If all groups are hidden, display a 'no results' message
            var visibleGroups = $('.js-contacts__group').filter(function() {
                return this.style.display !== 'none'
            }),
            noResults = $('.js-contacts__no-results');

            if(visibleGroups.length === 0) {
                noResults.show();
            }
            else {
                noResults.hide();
            }

        });
    }
}

export default Contacts;